<template>
  <div class="wrap"
       v-bind:class="{
        }"
  >
    <header class="lnbWrap">
      <div class="logo">
        <h1 id="logo">
          <template
          >
            <router-link to="/" title="" >
<!--              <img :src="SiteLogo.url" class="logImg" style="width:140px;"/>-->
            </router-link>
          </template>
        </h1>
      </div>
      <div class="lnbMenu">
        <nav class="nav_menu">

          <ul class="lnb" id="lnbBox">
              <sidebar-menu :menu="menuItem" :width="'210px'" />
          </ul>
        </nav>
      </div>
    </header>
    <div class="container lnb">
      <div class="header">
        <div class="h_left">
        </div>
        <div class="h_right util cursor logout_btn header_avatar">
          <img src="@/assets/image/common/mypage.png" alt="">
        </div>
        <div class="h_right util cursor logout_btn" @click="logout">
          <img src="@/assets/image/common/logout.png" alt="">
        </div>
      </div>
    </div>

  </div>
</template>


<script>
    import VuxAlert from '@/mixins/vux-alert';
    import Swal from 'sweetalert2'
    import { SidebarMenu } from 'vue-sidebar-menu'
    import setMenu from "@/mixins/setMenu";
    import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
    import {logout} from "@/mixins/Auth.js"
    export default {
        name: "PageHeader",
        mixins: [ VuxAlert, setMenu],
        components: {
            SidebarMenu
        },
        data(){
            return{
                lnbStatus : true,
                sideList: this.$router.options.routes,
                level: 0,
                File: {},
            }
        },
        created() {
        },
        computed: {
            metaName(){
                return this.$route.meta.title
            },
        },
        mounted() {
        },
        watch: {
            '$route.meta.name' : function(obj) {
                this.$store.state.navStatus = true;
            },
            '$route.path' : function() {
            },
        },
        methods: {
            logout() {
                let $this = this
                Swal.fire({
                  title: '',
                  text: '로그아웃 하시겠습니까?',
                  confirmButtonText:  "확인",
                  cancelButtonText: "취소",
                  showCancelButton: true,
                  // showCloseButton: true
                }).then((result) => {
                  if (result.value) {
                      $this.$store.dispatch('common/initUserInfo', {info : {}} );
                      logout();
                      this.$router.push('auth');
                  } else {

                  }
                });
            },
        },
    }
</script>

<style scoped>

</style>
